module.exports = __webpack_public_path__ + "media/images/fp-img-35959e5b04d64b04d7ea6253c286e8c2.jpg";